import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

interface ICardProps extends ComponentProps<"div"> {}

export const CardRouded = ({ className, ...rest }: ICardProps) => {
  return (
    <div
      {...rest}
      className={twMerge(
        "md:p-10 rounded-3xl md:border md:border-[#E5E5EA] md:border-solid w-full md:shadow-[0px_8px_24px_0px_#00000014]",
        className,
      )}
    />
  );
};
